import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { CheckIcon, ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import TwButton from "./TwButton";
import { classNames } from '../../helpers';
import { useTranslation } from "react-i18next";


export function TwNotificationDialog({ notificationDialogContent, closeNotificationDialog = () => { }, setNotificationDialogContent, updateNotificationDialog, dialogBackdropClick = () => { closeNotificationDialog() } }) {
     const { t, i18n } = useTranslation();
     const loadingReduxState = useSelector(loadingState);

     const getDialogBg = () => {
          return notificationDialogContent.dialogType === "success"
               ? "bg-green-100"
               : notificationDialogContent.dialogType === "error"
                    ? "bg-red-100"
                    : notificationDialogContent.dialogType === "warning"
                         ? "bg-yellow-100"
                         : notificationDialogContent.dialogType === "info"
                              ? "bg-blue-100"
                              : "bg-gray-100"
     };
     return (
          <Dialog open={notificationDialogContent.dialogOpen} onClose={dialogBackdropClick} className="relative z-40 pointer-events-none">
               <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
               />

               <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                         <DialogPanel
                              transition
                              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                         >
                              <div>
                                   {notificationDialogContent.dialogType !== "" && (<div className={`mx-auto flex size-12 items-center justify-center rounded-full ${getDialogBg()}`}>
                                        {notificationDialogContent.dialogType === "success"
                                             ? (<CheckIcon aria-hidden="true" className="size-6 text-green-600" />)
                                             : notificationDialogContent.dialogType === "error"
                                                  ? (<ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600" />)
                                                  : notificationDialogContent.dialogType === "warning"
                                                       ? (<ExclamationTriangleIcon aria-hidden="true" className="size-6 text-yellow-600" />)
                                                       : notificationDialogContent.dialogType === "info"
                                                            ? (<InformationCircleIcon aria-hidden="true" className="size-6 text-blue-600" />)
                                                            : ""}

                                   </div>)}
                                   <div className="mt-3 text-center sm:mt-5">
                                        <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                                             {notificationDialogContent.dialogTitle}
                                        </DialogTitle>
                                        <div className="mt-2">
                                             <p className="text-sm text-gray-500">
                                                  {notificationDialogContent.dialogMessage}
                                             </p>
                                        </div>
                                   </div>
                              </div>
                              <div className="mt-5 sm:mt-6">
                                   <TwButton
                                        className="w-full"
                                        disabled={(loadingReduxState.actionLoading)}
                                        actionLoading={(loadingReduxState.actionLoading)}
                                        onClick={async () => {
                                             if (notificationDialogContent.dialogBtnClick) {
                                                  await notificationDialogContent.dialogBtnClick({ notificationDialogContent, setNotificationDialogContent, updateNotificationDialog })
                                             } else {
                                                  closeNotificationDialog()
                                             }
                                        }}
                                   >
                                        {notificationDialogContent.dialogBtnTitle}
                                   </TwButton>
                              </div>
                         </DialogPanel>
                    </div>
               </div>
          </Dialog>
     );
}

export function TwConfirmDialog(props) {
     const { t, i18n } = useTranslation();
     const { children, className = "", dialogType = "", dialogOpen, id = 1, dialogTitle = t("bookings.warning"), dialogMessage = "", btnCloseText = "No", btnCloseVariant = "secondary-outline", isCrossCloseBtn = true, isCloseBtn = true, onClose = () => { }, btnConfirmText = "Yes", btnConfirmVariant = "danger", isConfirmBtn = true, onConfirm = () => { } } = props

     const [dialogConfirmOpen, setConfirmDialogOpen] = useState(false)
     const zIndex = `z-[${1001 + id}]`

     const getDialogBg = () => {
          return dialogType === "success"
               ? "bg-green-100"
               : dialogType === "error"
                    ? "bg-red-100"
                    : dialogType === "warning"
                         ? "bg-yellow-100"
                         : dialogType === "info"
                              ? "bg-blue-100"
                              : ""
     };

     useEffect(() => {
          setConfirmDialogOpen(props.dialogOpen)
          return () => { }
     }, [dialogOpen])

     return (
          <Dialog key={id} open={dialogConfirmOpen} onClose={() => {
               onClose()
               setConfirmDialogOpen(false)
          }} className={`relative z-50 ${zIndex}`}>
               <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
               />

               <div className={`fixed inset-0 z-50 ${zIndex} w-screen overflow-y-auto`}>
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                         <DialogPanel
                              transition
                              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                         >
                              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                   {isCrossCloseBtn && (<button
                                        type="button"
                                        onClick={() => {
                                             onClose()
                                             setConfirmDialogOpen(false)
                                        }}
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                   >
                                        <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                                        <XMarkIcon aria-hidden="true" className="size-6" />
                                   </button>)}
                              </div>
                              <div className="sm:flex sm:items-start">
                                   {dialogType !== "" && (<div className={`mx-auto flex size-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:size-10 ${getDialogBg()}`}>
                                        {dialogType === "success"
                                             ? (<CheckIcon aria-hidden="true" className="size-6 text-green-600" />)
                                             : dialogType === "error"
                                                  ? (<ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600" />)
                                                  : dialogType === "warning"
                                                       ? (<ExclamationTriangleIcon aria-hidden="true" className="size-6 text-yellow-600" />)
                                                       : dialogType === "info"
                                                            ? (<InformationCircleIcon aria-hidden="true" className="size-6 text-blue-600" />)
                                                            : ""}

                                   </div>)}
                                   <div className="mt-3 text-center sm:mx-4 sm:mt-0 sm:text-left w-full">
                                        {dialogTitle && (<DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                                             {dialogTitle}
                                        </DialogTitle>)}
                                        <div className="mt-2">
                                             {dialogMessage && (<p className="text-sm text-gray-500">
                                                  {dialogMessage}
                                             </p>)}
                                             {children}
                                        </div>
                                   </div>
                              </div>
                              <div className="mt-5 sm:mt-4 flex gap-3 flex-col sm:flex-row-reverse">
                                   {isConfirmBtn && (<TwButton
                                        variant={btnConfirmVariant}
                                        onClick={() => {
                                             onConfirm()
                                             setConfirmDialogOpen(false)
                                        }}
                                        className="inline-flex w-full justify-center px-3 py-2 sm:w-auto sm:min-w-28"
                                   >
                                        {btnConfirmText}
                                   </TwButton>)}
                                   {isCloseBtn && (<TwButton
                                        variant={btnCloseVariant}
                                        onClick={() => {
                                             onClose()
                                             setConfirmDialogOpen(false)
                                        }}
                                        className="inline-flex w-full justify-center px-3 py-2 sm:w-auto sm:min-w-28"
                                   >
                                        {btnCloseText}
                                   </TwButton>)}
                              </div>
                         </DialogPanel>
                    </div>
               </div>
          </Dialog>
     )
}

export function TwDialog(props) {
     const { t, i18n } = useTranslation();
     const { children, className = "", dialogOpen, id = 1, dialogTitle = "", dialogMessage = "", isFullContent = false, isAllowBackdropClick = true, showXBtn = true, btnChildren, onClose = (dialogConfirmOpen = false) => { } } = props

     const [dialogConfirmOpen, setConfirmDialogOpen] = useState(false)
     const zIndex = `z-[${1001 + id}]`


     useEffect(() => {
          setConfirmDialogOpen(props.dialogOpen)
          return () => { }
     }, [dialogOpen])

     return (
          <Dialog key={id} open={dialogConfirmOpen} onClose={() => {
               if (isAllowBackdropClick == true) {
                    setConfirmDialogOpen(false)
               }
          }} className={`relative z-50 ${zIndex}`}>
               <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
               />

               <div className={`fixed inset-0 z-50 ${zIndex} w-screen overflow-y-auto`}>
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                         <DialogPanel
                              transition
                              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                         >
                              {showXBtn && (<div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
                                   <button
                                        type="button"
                                        onClick={() => {
                                             onClose(dialogConfirmOpen)
                                             setConfirmDialogOpen(false)
                                        }}
                                        className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                   >
                                        <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                                        <XMarkIcon aria-hidden="true" className="size-6" />
                                   </button>
                              </div>)}
                              <div className="sm:flex sm:items-start">
                                   <div className={classNames("mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left", isFullContent ? "w-full" : "")}>
                                        {dialogTitle && (<DialogTitle as="h3" className="text-xl font-bold text-gray-900">
                                             {dialogTitle}
                                        </DialogTitle>)}
                                        <div className="mt-2">
                                             {dialogMessage && (<p className="text-sm text-gray-500">
                                                  {dialogMessage}
                                             </p>)}
                                             {children}
                                        </div>
                                   </div>
                              </div>
                              {btnChildren && (<div className="mt-5 sm:mt-4 flex gap-3 flex-col sm:flex-row-reverse">
                                   {btnChildren}
                              </div>)}
                         </DialogPanel>
                    </div>
               </div>
          </Dialog>
     )
}
